/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICartIconViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./cart-icon';
import { IFlyoutCartLineItemViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./components/flyout-cart-line-items';
import { getUrlSync } from '@msdyn365-commerce/core';
import { ICartIconProps } from '../definition-extensions/cart-icon.ext.props.autogenerated';
const _renderCartlines = (cartLines: IFlyoutCartLineItemViewProps[] | undefined, props: ICartIconViewProps): JSX.Element[] | null => {
    if (!cartLines) {
        props.context.telemetry.error('Cartlines content is empty, module wont render');
        return null;
    }
    return cartLines.map((cartLine, index) => {
        return (
            <Node {...props.miniCartItemWrapper} key={index}>
                {cartLine.cartline}
                {cartLine.storeLocation}
                {/* {cartLine.remove} */}
            </Node>
        );
    });
};

const CartIconView: React.FC<ICartIconViewProps & ICartIconProps<{}>> = (props: ICartIconViewProps & ICartIconProps<{}>) => {
    const getCheckoutPageUrl = (): string => {
        return getUrlSync('checkout', props.context.actionContext) ?? '';
    };
    const renderCheckoutAsSignInUserButton = ()=>{
        if(props.checkoutAsSignInUserButton){
            const clonedCheckoutAsSignInUserButton = React.cloneElement(props.checkoutAsSignInUserButton as JSX.Element, {
                href: getCheckoutPageUrl(),
            });
            return clonedCheckoutAsSignInUserButton
        }else{
            return null
        }
    }
    const {resources : {szfcartQtyLabel}} = props
    let clonedCartIcon = React.cloneElement(props.cartIcon as JSX.Element, {cartQtyLabel : szfcartQtyLabel});

    return(
        <Node  {...props.miniCartWrapper} {...props.renderModuleAttributes(props)} className={`${props.config.showCartIcon ? "ms-cart-icon" : "ms-cart-icon d-none" }`}>
            {/* {props.cartIcon} */}
            {clonedCartIcon}
            {props.FlyoutContainer ? (
                <Node {...props.FlyoutContainer}>
                    {props.flyoutTitle}
                    {props.checkoutBlockedDueToUnavailableFunds}
                    <Node {...props.CartlinesWrapper}>{_renderCartlines(props.cartlines, props)}</Node>
                    {props.totalPrice}
                    {/* {props.checkoutAsSignInUserButton} */}
                    {/* {props.checkoutAsGuestButton} */}
                    {renderCheckoutAsSignInUserButton()}
                    {props.goToCartButton}
                </Node>
            ) : (
                false
            )}
        </Node>
    )
};

export default CartIconView;
